import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

import { isAgent } from '../../../../lib/flow/pageHelpers';

function isEnabled({ answers, inputContext: { channel } }: FlowContext) {
  return !isAgent(answers, channel) && !answers['seller.exclusives_customer_phone_number'];
}

const phoneNumberPage: FlowPage = {
  slug: () => 'exclusives-phone',
  title: () => "You're all set! Your offer is ready to go.",
  subtitle: () => "Add your info so we know who it's for.",
  autoAdvance: () => false,
  isEnabled,
  questions: (): FlowQuestion[] => {
    return [
      {
        key: 'seller.full_name',
        type: 'single_line',
        label: 'Full name (required)',
        placeholder: 'John Smith',
        optional: false,
      },
      {
        key: 'seller.exclusives_customer_phone_number',
        type: 'phone',
        label: 'Phone number (required)',
        placeholder: '555-867-5309',
        optional: false,
      },
    ];
  },
  note: () =>
    'By clicking "View Offer" I agree that Opendoor may call or text me about my inquiry, including by automated means. I may opt out at any time, and consent is not a condition of using Opendoor\'s services.',
};

export default phoneNumberPage;
